export default __webpack_public_path__ + "static/media/alkelio-catalyst-default.4fe4d193.jpg";